import logo0 from "./images/icons/0sandals.png";
import logo1 from "./images/icons/0.png";
import logo2 from "./images/icons/1.png";
import logo3 from "./images/icons/2.png";
import logo4 from "./images/icons/3.png";
import logo5 from "./images/icons/4.png";
import logo6 from "./images/icons/5.png";
import logo7 from "./images/icons/6.png";
import logo8 from "./images/icons/7.png";
import logo9 from "./images/icons/8.png";
import logo10 from "./images/icons/9.png";
import logo11 from "./images/icons/10.png";
import logo12 from "./images/icons/11.png";
import logo13 from "./images/icons/12.png";
import logo14 from "./images/icons/13.png";
import logo15 from "./images/icons/14.png";
import logo16 from "./images/icons/15.png";
import logo17 from "./images/icons/16.png";
import logo18 from "./images/icons/17.png";
import logo19 from "./images/icons/18.png";

import iconPagar from "./images/icons/pagar.png";
import iconAutorizar from "./images/icons/autorizar.png";
import iconBuscar from "./images/icons/Buscar.png";
import iconLaptop from "./images/icons/icon laptop.png";
import iconMaleta from "./images/icons/icon maleta.png";
import iconAvion from "./images/icons/icon avión.png";
import iconPass from "./images/icons/pasaporte.png";

import imgEssential from "./images/Essential.png";
import imgComplete from "./images/Complete.png";
import imgElite from "./images/Elite.png";
import { getMarkup } from "./services/adminProductService";

export const logosCadenasHoteleras = [
  logo0,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
];

export const infoPayMethods = [
  {
    icon: iconPagar,
    title: "Consulta las tarjetas participantes",
    description:
      "Aceptamos tarjetas Visa y Mastercard, consulta promociones vigentes. Compara también a meses diferidos.",
  },
  {
    icon: iconAutorizar,
    title: "¿Aún no te sientes seguro?",
    description:
      "Asesoría gratuita, en todos nuestros servicios cuentas con garantía de satisfacción. *Consulta con un asesor",
  },
  {
    icon: iconBuscar,
    title: "Ahora es más fácil comprar en nuestro sitio web",
    description:
      "Compra directamente en línea y dispone a disfrutar al instante.",
  },
];

export const infoSpecialCircuits = [
  {
    icon: iconLaptop,
    title: "Ahora es más fácil comprar y consultar en nuestro sitio web",
    description:
      "Consulta miles de hoteles y cientos de circuitos por el mundo.",
  },
  {
    icon: iconMaleta,
    title: "Planea tu próximo viaje",
    description:
      "Ya sea a hoteles nacionales o internacionales, somos expertos en ofrecer las mejores experiencias.",
  },
  {
    icon: iconAvion,
    title: "Servicios que incluimos",
    description:
      "Consulta sobre todos los servicios de valor agregado que ofrecemos. Vuelos, transportación y mucho más.",
  },
];

export const infoCursos = [
  {
    icon: iconLaptop,
    title: "Consulta los cursos e infórmate en nuestro sitio web",
    description:
      "Infórmate de todos los cursos y campamentos vigentes, descarga el brochure informativo.",
  },
  {
    icon: iconPass,
    title: "Prepara tus documentos",
    description:
      "Si no cuentas con Visa, podemos orientarte para gestionar una Visa de estudiante y/o toda la documentación necesaria.",
  },
  {
    icon: iconMaleta,
    title: "Haz la maleta y planea tu Curso o Campamento",
    description:
      "Nuestros asesores están encantados de facilitarte toda la información necesaria para tu viaje.",
  },
  {
    icon: iconAvion,
    title: "Prepárate para una experiencia de vida",
    description: "Viva cada momento, ya que será un viaje inolvidable.",
  },
];

export const planSegurosData = [
  {
    urlImg: imgEssential,
    title: "Plan Total",
    coverAmount: "$7.00 USD",
    description: "Cobertura completa del plan Total.",
    modalContent: [
      {
        title: "Plan Total",
        sections: [
          {
            subtitle: "",
            items: [
              {
                description: "Gastos médicos por accidente",
                price: "EUR / USD 35.000",
              },
              {
                description: "Gastos médicos por Enfermedad no Preexistente",
                price: "EUR / USD 35.000",
              },
              {
                description: "Gastos médicos por hospitalización",
                price: "EUR / USD 35.000",
              },
              {
                description: "Gastos médicos por Covid-19",
                price: "USD 35,000 / €35,000",
              },
              {
                description: "Gastos médicos por enfermedad preexistente",
                price: "USD 500",
              },
              {
                description: "Gastos médicos por complicaciones de embarazo",
                price: "USD 500",
              },
              { description: "Medicamentos recetados", price: "Incluido" },
              { description: "Emergencia dental", price: "USD 500" },
              { description: "Evacuación Médica", price: "EUR / USD 35.000" },
              {
                description: "Repatriación Sanitaria",
                price: "EUR / USD 35.000",
              },
              {
                description: "Repatriación Funeraria",
                price: "EUR / USD 35.000",
              },
              {
                description: "Traslado de familiar por hospitalización",
                price: "Tkt aéreo + hotel",
              },
              {
                description: "Gastos de hotel por convalecencia",
                price: "USD 1.000",
              },
              {
                description:
                  "Asistencia en caso de extravío de documentos, equipajes",
                price: "Incluido",
              },
              {
                description: "Viaje de regreso por fallecimiento de familiar",
                price: "Tkt aéreo",
              },
              {
                description: "Regreso por siniestro grave en domicilio",
                price: "Tkt aéreo",
              },
              {
                description: "Acompañamiento de menores de 15 años",
                price: "Tkt aéreo",
              },
              {
                description: "Acompañamiento de mayores de 75 años",
                price: "Tkt aéreo",
              },
              {
                description: "Gastos por vuelo demorado o cancelado",
                price: "USD 100",
              },
              {
                description: "Cancelación o Interrupción de viaje contratado",
                price: "USD 2.000",
              },
              {
                description: "Substitución de ejecutivo",
                price: "Tkt aéreo + hotel",
              },
              { description: "Línea de consultas 24 Horas", price: "Incluido" },
              {
                description: "Transmisión de mensajes urgentes",
                price: "Incluido",
              },
              { description: "Transferencia de fondos", price: "USD 15.000" },
              {
                description: "Transferencia de fondos para fianza legal",
                price: "USD 15.000",
              },
              {
                description: "Asistencia legal por accidente de tránsito",
                price: "USD 7.000",
              },
              {
                description: "Compensación por pérdida de equipaje aéreo",
                price: "USD 1.200",
              },
              {
                description: "Compensación por pérdida de equipaje en cruceros",
                price: "USD 500",
              },
              {
                description: "Compensación por demora de equipaje",
                price: "USD 500",
              },
              {
                description: "Compensación por daño de equipaje",
                price: "USD 100",
              },
              {
                description: "Pérdida o conexión de vuelo o tren",
                price: "USD 400",
              },
              { description: "Pérdida de pasaporte", price: "USD 100" },
              { description: "Asistencia psicológica", price: "Incluido" },
              { description: "Médico virtual/Telefónico", price: "Incluido" },
              { description: "Segunda opinión médica", price: "Incluido" },
              {
                description: "Pérdida de embarque en crucero",
                price: "Tkt aéreo",
              },
              { description: "Servicios de Concierge", price: "Incluido" },
              {
                description: "Práctica de deportes amateur",
                price: "USD 1.000",
              },
              {
                description: "Muerte accidental 24 horas",
                price: "USD 50,000",
              },
              { description: "Pérdidas Orgánicas", price: "USD 50.000" },
              {
                description: "Cobertura Geográfica",
                price: "Mundial y Europa",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    urlImg: imgComplete,
    title: "Plan Maximus",
    coverAmount: "$9.00 USD",
    description: "Cobertura completa del plan Maximus.",
    modalContent: [
      {
        title: "Plan Maximus",
        sections: [
          {
            subtitle: "",
            items: [
              {
                description: "Gastos médicos por accidente",
                price: "USD 60.000",
              },
              {
                description: "Gastos médicos por Enfermedad no Preexistente",
                price: "USD 60.000",
              },
              {
                description: "Gastos médicos por hospitalización",
                price: "USD 60.000",
              },
              {
                description: "Gastos médicos por Covid-19",
                price: "USD 50.000",
              },
              {
                description: "Gastos médicos por enfermedad preexistente",
                price: "USD 1.000",
              },
              {
                description: "Gastos médicos por complicaciones de embarazo",
                price: "N/A",
              },
              { description: "Medicamentos recetados", price: "Incluido" },
              { description: "Emergencia dental", price: "USD 800" },
              { description: "Evacuación Médica", price: "USD 60.000" },
              { description: "Repatriación Sanitaria", price: "USD 60.000" },
              { description: "Repatriación Funeraria", price: "USD 60.000" },
              {
                description: "Traslado de familiar por hospitalización",
                price: "Tkt aéreo + hotel",
              },
              {
                description: "Gastos de hotel por convalecencia",
                price: "USD 1.200",
              },
              {
                description:
                  "Asistencia en caso de extravío de documentos, equipajes",
                price: "Incluido",
              },
              {
                description: "Viaje de regreso por fallecimiento de familiar",
                price: "Tkt aéreo",
              },
              {
                description: "Regreso por siniestro grave en domicilio",
                price: "Tkt aéreo",
              },
              {
                description: "Acompañamiento de menores de 15 años",
                price: "Tkt aéreo",
              },
              {
                description: "Acompañamiento de mayores de 75 años",
                price: "Tkt aéreo",
              },
              {
                description: "Gastos por vuelo demorado o cancelado",
                price: "USD 150",
              },
              {
                description: "Cancelación o Interrupción de viaje contratado",
                price: "USD 2.000",
              },
              {
                description: "Substitución de ejecutivo",
                price: "Tkt aéreo + hotel",
              },
              { description: "Línea de consultas 24 Horas", price: "Incluido" },
              {
                description: "Transmisión de mensajes urgentes",
                price: "Incluido",
              },
              { description: "Transferencia de fondos", price: "USD 20.000" },
              {
                description: "Transferencia de fondos para fianza legal",
                price: "USD 20.000",
              },
              {
                description: "Asistencia legal por accidente de tránsito",
                price: "USD 10.000",
              },
              {
                description: "Compensación por pérdida de equipaje aéreo",
                price: "USD 1.500",
              },
              {
                description: "Compensación por pérdida de equipaje en cruceros",
                price: "USD 600",
              },
              {
                description: "Compensación por demora de equipaje",
                price: "USD 500",
              },
              {
                description: "Compensación por daño de equipaje",
                price: "USD 100",
              },
              {
                description: "Pérdida o conexión de vuelo o tren",
                price: "USD 400",
              },
              { description: "Pérdida de pasaporte", price: "USD 100" },
              { description: "Asistencia psicológica", price: "Incluido" },
              { description: "Médico virtual/Telefónico", price: "Incluido" },
              { description: "Segunda opinión médica", price: "Incluido" },
              {
                description: "Pérdida de embarque en crucero",
                price: "Tkt aéreo",
              },
              { description: "Servicios de Concierge", price: "Incluido" },
              {
                description: "Práctica de deportes amateur",
                price: "USD 1.000",
              },
              {
                description: "Muerte accidental 24 horas",
                price: "USD 50,000",
              },
              { description: "Pérdidas Orgánicas", price: "USD 50.000" },
              { description: "Cobertura Geográfica", price: "Mundial" },
            ],
          },
        ],
      },
    ],
  },
  {
    urlImg: imgElite,
    title: "Plan Supreme",
    coverAmount: "$11.00 USD",
    description: "Cobertura completa del plan Supreme.",
    modalContent: [
      {
        title: "Plan Supreme",
        sections: [
          {
            subtitle: "",
            items: [
              {
                description: "Gastos médicos por accidente",
                price: "USD 100.000",
              },
              {
                description: "Gastos médicos por Enfermedad no Preexistente",
                price: "USD 100.000",
              },
              {
                description: "Gastos médicos por hospitalización",
                price: "USD 100.000",
              },
              {
                description: "Gastos médicos por Covid-19",
                price: "USD 50.000",
              },
              {
                description: "Gastos médicos por enfermedad preexistente",
                price: "USD 1.000",
              },
              {
                description: "Gastos médicos por complicaciones de embarazo",
                price: "N/A",
              },
              { description: "Medicamentos recetados", price: "Incluido" },
              { description: "Emergencia dental", price: "USD 1.000" },
              { description: "Evacuación Médica", price: "USD 60.000" },
              { description: "Repatriación Sanitaria", price: "USD 60.000" },
              { description: "Repatriación Funeraria", price: "USD 60.000" },
              {
                description: "Traslado de familiar por hospitalización",
                price: "Tkt aéreo + hotel",
              },
              {
                description: "Gastos de hotel por convalecencia",
                price: "USD 1.500",
              },
              {
                description:
                  "Asistencia en caso de extravío de documentos, equipajes",
                price: "Incluido",
              },
              {
                description: "Viaje de regreso por fallecimiento de familiar",
                price: "Tkt aéreo",
              },
              {
                description: "Regreso por siniestro grave en domicilio",
                price: "Tkt aéreo",
              },
              {
                description: "Acompañamiento de menores de 15 años",
                price: "Tkt aéreo",
              },
              {
                description: "Acompañamiento de mayores de 75 años",
                price: "Tkt aéreo",
              },
              {
                description: "Gastos por vuelo demorado o cancelado",
                price: "USD 200",
              },
              {
                description: "Cancelación o Interrupción de viaje contratado",
                price: "USD 2.000",
              },
              {
                description: "Substitución de ejecutivo",
                price: "Tkt aéreo + hotel",
              },
              { description: "Línea de consultas 24 Horas", price: "Incluido" },
              {
                description: "Transmisión de mensajes urgentes",
                price: "Incluido",
              },
              { description: "Transferencia de fondos", price: "USD 30.000" },
              {
                description: "Transferencia de fondos para fianza legal",
                price: "USD 30.000",
              },
              {
                description: "Asistencia legal por accidente de tránsito",
                price: "USD 15.000",
              },
              {
                description: "Compensación por pérdida de equipaje aéreo",
                price: "USD 2.000",
              },
              {
                description: "Compensación por pérdida de equipaje en cruceros",
                price: "USD 800",
              },
              {
                description: "Compensación por demora de equipaje",
                price: "USD 800",
              },
              {
                description: "Compensación por daño de equipaje",
                price: "USD 100",
              },
              {
                description: "Pérdida o conexión de vuelo o tren",
                price: "USD 500",
              },
              { description: "Pérdida de pasaporte", price: "USD 100" },
              { description: "Asistencia psicológica", price: "Incluido" },
              { description: "Médico virtual/Telefónico", price: "Incluido" },
              { description: "Segunda opinión médica", price: "Incluido" },
              {
                description: "Pérdida de embarque en crucero",
                price: "Tkt aéreo",
              },
              { description: "Servicios de Concierge", price: "Incluido" },
              {
                description: "Práctica de deportes amateur",
                price: "USD 1.000",
              },
              {
                description: "Muerte accidental 24 horas",
                price: "USD 50,000",
              },
              { description: "Pérdidas Orgánicas", price: "USD 100.000" },
              { description: "Cobertura Geográfica", price: "Mundial" },
            ],
          },
        ],
      },
    ],
  },
];

export const infoPlanesXv = [
  {
    title: "Europa 1",
    subtitle: "Disfruta de 31 días llenos de magia y la diversión sin fin",
    day: "Itinerario de 31 Días",
    itinerary: [
      {
        nameTab: "¿Qué incluye?",
        location: "",
        activitie:
          "3 Personas Cena de Gala en México, Sesión informativa del programa , Avión (México - París - Madrid - México), Traslados aeropuertos - hotel - aeropuerto, Autocar de Lujo, Euro Túnel (Calais - Folkestone / Folkestone - Calais), Hoteles de Lujo, Alimentos descritos según itinerario, Conductoras desde México, Visitas Panorámicas, Seguro de Viaje, Playera y Mochila",
      },
      {
        nameTab: "¿Qué destinos visitan?",
        location: "",
        activitie:
          "Paris, Visita exterior al Museo de Louvre, Barcos del Sena, Hard Rock Café, Torre Eiffel, Euro Disney, Londres, Museo de Cera: Madame Tussauds, Warner Bros: The Making of Harry Potter, Torre de Londres, Cambio de Guardia,Hard Rock Café, Amsterdam, Zaanse Schans, Hard Rock Café, Praga, Hard Rock Café, Viena, Gran Baile en Viena, Innsbruck, Fábrica de Swarovski, Engelberg, Monte Titlis, Paseo en Góndola, Isla del Lido de Venecia, Roma, Basílica de San Pedro, Visita exterior al Coliseo Romano, Hard Rock Café Siena, Plaza del Campo, Reliquias de Santa Catarina, Florencia, Hard Rock Café, Monaco, Casino de Montecarlo, Barcelona, Camp Nou, Sagrada Familia, Hard Rock Café, Zaragoza, Basílica del Pilar, Comida en típico restaurante Aragonés, Madrid, Estadio Santiago Bernabéu, Warner Bros Park, Toledo, Cena de Despedida en un Restaurante de Lujo",
      },
      {
        nameTab: "06 de Julio",
        location: "",
        activitie: "Cena de Gala.",
      },
      {
        nameTab: "07 de Julio",
        location: "MÉXICO - PARÍS",
        activitie: "Salida en vuelo Intercontinental con destino a París.",
      },
      {
        nameTab: "08 de Julio",
        location: "París",
        activitie:
          "Llegada al Aeropuerto Charles de Gaulle, recepción de Quinceañeras, traslado al hotel. Cena. Alojamiento.",
      },
      {
        nameTab: "09 de Julio",
        location: "París",
        activitie:
          "Panorámica en autocar viendo los monumentos: la Sorbona, el Panteón, el Palacio y la Torre Eiffel, la Plaza de la Concordia, el Arco del Triunfo, la Plaza Vendome, la Ópera. COMIDA en Hard Rock Cafe. Paseo en Barco por el Río Sena. Tiempo de Compras en los Campos Elíseos. Alojamiento.",
      },
      {
        nameTab: "10 de Julio",
        location: "París",
        activitie:
          "Visita exterior al Museo de Louvre. Visita a EURO DISNEY. Alojamiento.",
      },
      {
        nameTab: "11 de Julio",
        location: "París - Londres",
        activitie:
          "Salida a Calais para atravesar el Canal de la Mancha. Continuación a Londres. CENA. Alojamiento.",
      },
      {
        nameTab: "12 de Julio",
        location: "Londres",
        activitie:
          "Visita de la ciudad admirando La Torre y el Puente de Londres, El Palacio de Buckingham (Cambio De Guardia), Hyde Park, Saint James Park, Piccadilly Circus. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "13 de Julio",
        location: "Londres",
        activitie:
          "Visita al Museo de cera Madame Tussauds. Estudios Warner Bros. CENA. Alojamiento.",
      },
      {
        nameTab: "14 de Julio",
        location: "Brujas - Ámsterdam",
        activitie:
          "Visita a Brujas “La Bella”. Continuación a Ámsterdam. CENA. Alojamiento.",
      },
      {
        nameTab: "15 de Julio",
        location: "Ámsterdam",
        activitie:
          "Visita de la Ciudad: La Plaza Dam, El Mercado de Flores, El Canal de Singel. Visita al parque Zaanse Schans. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "16 de Julio",
        location: "Ámsterdam - Frankfurt",
        activitie:
          "Crucero por el Río Rhin. Llegada a Frankfurt. CENA. Alojamiento.",
      },
      {
        nameTab: "17 de Julio",
        location: "Frankfurt - Núremberg - Praga",
        activitie:
          "Visita a Núremberg. Continuación a Praga. CENA. Alojamiento.",
      },
      {
        nameTab: "18 de Julio",
        location: "Praga",
        activitie:
          "Visita al Castillo, la Plaza del Ayuntamiento y el Puente de Carlos. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "19 de Julio",
        location: "Praga - Budapest",
        activitie: "Llegada a Budapest. CENA. Alojamiento.",
      },
      {
        nameTab: "20 de Julio",
        location: "Budapest - Viena",
        activitie:
          "Visita de Buda y Pest con sus zonas comerciales. Continuación a Viena. CENA. Alojamiento.",
      },
      {
        nameTab: "21 de Julio",
        location: "Viena",
        activitie:
          "Visita al Palacio Hofburg, Jardines de Belvedere y Palacio Schönbrunn. GRAN CENA BAILE. Alojamiento.",
      },
      {
        nameTab: "22 de Julio",
        location: "Viena - Salzburgo - Innsbruck",
        activitie:
          "Visita a Salzburgo. Continuación a Innsbruck. CENA. Alojamiento.",
      },
      {
        nameTab: "23 de Julio",
        location: "Innsbruck - Lucerna",
        activitie:
          "Visita a Innsbruck. Continuación a Lucerna. CENA. Alojamiento.",
      },
      {
        nameTab: "24 de Julio",
        location: "Lucerna",
        activitie:
          "Visita a la ciudad, Monte Titlis y paisajes nevados. CENA. Alojamiento.",
      },
      {
        nameTab: "25 de Julio",
        location: "Lucerna - Milán - Venecia",
        activitie: "Visita a Milán. Continuación a Venecia. CENA. Alojamiento.",
      },
      {
        nameTab: "26 de Julio",
        location: "Venecia",
        activitie:
          "Visita a la Plaza de San Marcos, Basílica de San Marcos y paseo en Góndola. CENA. Alojamiento.",
      },
      {
        nameTab: "27 de Julio",
        location: "Venecia - Florencia - Roma",
        activitie:
          "Visita a Florencia. COMIDA en Hard Rock Cafe. Continuación a Roma. Alojamiento.",
      },
      {
        nameTab: "28 de Julio",
        location: "Roma",
        activitie:
          "Visita a la Basílica de San Pedro, Plaza Navona, Fuente de Trevi y Coliseo Romano. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "29 de Julio",
        location: "Roma - Siena - Pisa",
        activitie: "Visita a Siena y Pisa. CENA. Alojamiento.",
      },
      {
        nameTab: "31 de Julio",
        location: "Mónaco - Barcelona",
        activitie: "Llegada a Barcelona. CENA. Alojamiento.",
      },
      {
        nameTab: "01 de Agosto",
        location: "Barcelona",
        activitie:
          "Visita a la Sagrada Familia, Plaza Cataluña y Las Ramblas. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "02 de Agosto",
        location: "Barcelona - Zaragoza - Madrid",
        activitie:
          "Visita a Zaragoza y la Basílica del Pilar. COMIDA en Restaurante Aragonés. Continuación a Madrid. Alojamiento.",
      },
      {
        nameTab: "03 de Agosto",
        location: "Madrid",
        activitie:
          "Visita a Toledo y principales avenidas de Madrid. COMIDA en Restaurante Toledano. Alojamiento.",
      },
      {
        nameTab: "04 de Agosto",
        location: "Madrid",
        activitie:
          "Visita al Estadio Santiago Bernabéu y Warner Bros Park. CENA DE DESPEDIDA. Alojamiento.",
      },
      {
        nameTab: "05 de Agosto",
        location: "Madrid",
        activitie: "Visita a un outlet para compras. CENA. Alojamiento.",
      },
      {
        nameTab: "06 de Agosto",
        location: "Madrid",
        activitie: "Traslado al aeropuerto para vuelo a México.",
      },
    ],
  },
  {
    title: "Europa 2",
    subtitle: "Un fabuloso y mágico viaje",
    day: "Itinerario de 26 días",
    itinerary: [
      {
        nameTab: "¿Qué incluye?",
        location: "",
        activitie:
          "3 Personas Cena de Gala en México, Sesión informativa del programa, Avión México - París, Madrid - México, Traslados aeropuerto - hotel - aeropuerto, Autocar de Lujo, Euro Túnel, Calais - Folkestone, Folkestone - Calais, Alojamiento en Turista Superior y Primera, Alimentos descritos según itinerario, Conductoras desde México, Seguro de Viaje, Playera y Mochila",
      },
      {
        nameTab: "¿Qué destinos visitan?",
        location: "",
        activitie:
          "PARIS , Visita exterior al Museo de Louvre, Barcos del Sena, Hard Rock Cafe, Torre Eiffel, Euro Disney, LONDON, Warner Bros: The Making of Harry Potter, Cambio de Guardia, Hard Rock Cafe, Museo de Cera: Madame Tussauds, London Eye, BRUSSELS, Gran Plaza y Menneken Pis, ENGELBERG, Monte Titlis, INNSBRUCK, Fábrica de Swarovski, VIENNA, Gran Baile de Viena, VENICE, Paseo en Góndola, Isla del Lido de Venecia, FLORENCE, Hard Rock Cafe, ROME, Basílica de San Pedro, Visita exterior al Coliseo Romano, Hard Rock Café, SIENA, Plaza del Campo, Reliquias de Santa Catarina, MONACO, Casino de Montecarlo, BARCELONA, Camp Nou, Sagrada Familia, Hard Rock Café, ZARAGOZA, Basílica del Pilar, Comida en típico Restaurante Aragonés, MADRID, Estadio Bernabéu, Warner Bros Park, Toledo",
      },
      {
        nameTab: "06 de Julio",
        location: "",
        activitie: "Cena de Gala.",
      },
      {
        nameTab: "10 de Julio",
        location: "MÉXICO - PARÍS",
        activitie: "Salida en vuelo Intercontinental con destino a París.",
      },
      {
        nameTab: "11 de Julio",
        location: "PARÍS",
        activitie:
          "Llegada al Aeropuerto Charles de Gaulles, recepción de Quinceañeras, traslado al hotel. CENA. Alojamiento.",
      },
      {
        nameTab: "12 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Panorámica en autocar viendo los monumentos: la Sorbona, el Panteón, el Palacio y la Torre Eiffel, la Plaza de la Concordia, el Arco del Triunfo, la Plaza Vendome, la Ópera. COMIDA en Hard Rock Café Disfrutaremos un paseo en Barco por el Río Sena, Tiempo de Compras en los Campos Elíseos. Alojamiento.",
      },
      {
        nameTab: "13 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Esta mañana la dedicaremos una visita exterior al Museo de Louvre y por la tarde visitaremos EURO DISNEY. CENA. Alojamiento.",
      },
      {
        nameTab: "14 de Julio",
        location: "PARÍS - LONDRES",
        activitie:
          "Desayuno. Salida a Calais para atravesar el Canal de la Mancha. Continuación a Londres. CENA. Alojamiento.",
      },
      {
        nameTab: "15 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Visita de la ciudad admirando La Torre y el Puente de Londres, El Palacio de Buckingham (Cambio De Guardia si se realiza), los preciosos Hyde Park y Saint James Park las calles de la moda. Por la tarde visita exterior a la famosa Noria de Londres (London Eye) Tiempo de Compras en Piccadilly Circus. COMIDA en Hard Rock Cafe.. Alojamiento.",
      },
      {
        nameTab: "16 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Por la mañana visita al Museo de cera Madame Tussauds. Continuación a los Estudios Warner Bros, para imaginar cómo se filmaron las hermosas películas de Harry Potter. CENA. Alojamiento.",
      },
      {
        nameTab: "17 de Julio",
        location: "LONDRES - BRUJAS - BRUSELAS",
        activitie:
          "Desayuno. Saldremos a primera hora para atravesar el Canal de la Mancha y llegar a Brujas “La Bella” una de las más pintorescas ciudades de Europa, un museo romántico al aire libre hecho de iglesias, casas principales, canales famosos donde realizaremos un paseo. Tendremos tiempo para comprar sus famosos encajes, cerámica y chocolates. Continuación a Bruselas para conocer su Gran Plaza y el Mennenken Pis, uno de los grandes símbolos de la ciudad. CENA. Alojamiento.",
      },
      {
        nameTab: "18 de Julio",
        location: "BRUSELAS - Crucero por el Rhin - FRANKFURT",
        activitie:
          "Desayuno. Salida a Boppard, bella Ciudad Alemana a orillas de Río Rhin abordaremos un Crucero donde disfrutaremos panorámicas de bellos Castillos y llegaremos a St. Goard. Continuación a Frankfurt CENA. Alojamiento.",
      },
      {
        nameTab: "19 de Julio",
        location: "FRANKFURT - NÚREMBERG - PRAGA",
        activitie:
          "Desayuno. Salida a Núremberg, visita a pie por la ciudad antigua “Pintoresca” de la Baviera pasearemos por las murallas medievales con coloridos edificios, aprenderemos sobre las raíces Romanas y vínculos con el tercer Reich (inicio del régimen Nazi) caminaremos junto al Río Pegnitz, la iglesia de San Lorenzo y el Castillo de Núremberg. Continuación a Praga. CENA. Alojamiento.",
      },
      {
        nameTab: "20 de Julio",
        location: "PRAGA - VIENA",
        activitie:
          "Desayuno. Conoceremos Praga una de las más hermosas ciudades de Europa donde destacan el Castillo, la Praga del Ayuntamiento y el hermoso Puente de Carlos. COMIDA en Hard Rock Cafe. Continuación a Viena. Alojamiento.",
      },
      {
        nameTab: "21 de Julio",
        location: "VIENA",
        activitie:
          "Desayuno. Visitaremos la ciudad, bañada por el Danubio, Antigua capital del Imperio Austrohúngaro, en el centro de Viena se encuentra la antigua Ciudad Imperial con el Palacio Hofburg residencia de los Emperadores, visitaremos los Jardines de Belvedere y el Palacio Schönbrunn la Iglesia de Votiva, la Catedral de San Esteban la Ópera. Por la noche GRAN CENA BAILE. Alojamiento.",
      },
      {
        nameTab: "22 de Julio",
        location: "VIENA - INNSBRUCK",
        activitie:
          "Desayuno. Salida hacia Innsbruck visitaremos a pie esta ciudad situada en el interior de la Cadena Alpina. Capital del Tirol, una de las regiones más atractivas de Europa por el incomparable marco de sus montañas y su cielo limpio. La ciudad se encuentra rodeada de maravillosos paisajes y centros deportivos de invierno, Visita a la Fábrica Swarosky. CENA. Alojamiento.",
      },
      {
        nameTab: "23 de Julio",
        location: "INNSBRUCK - ENGELBERG - LUCERNA",
        activitie:
          "Desayuno. Salida a Engelberg donde visitaremos Monte Titlis con el único funicular giratorio en el mundo, donde nos sorprenderán sus impresionantes paisajes y en lo más alto disfrutaremos de la nieve Continuación a Lucerna para admirar su puente Medieval así como la ciudad vieja. CENA. Alojamiento.",
      },
      {
        nameTab: "24 de Julio",
        location: "LUCERNA - VERONA - VENECIA",
        activitie:
          "Desayuno. Salida a Verona ciudad mundialmente famosa por la historia de Romeo y Julieta. Continuación a Venecia. CENA. Alojamiento.",
      },
      {
        nameTab: "25 de Julio",
        location: "VENECIA",
        activitie:
          "Desayuno. Visita a pie de esta ciudad única en el mundo asentada sobre 118 islas en el Mar Adriático. Es impresionante la Plaza de San Marcos que forma un maravilloso conjunto arquitectónico con la Basílica de San Marcos Puente de los Suspiros, Campanille y Palacio Ducal pasearemos en Góndola por sus innumerables canales, traslado a Lido de Venecia para disfrutar de un buen chapuzón en el Mar Adriático. CENA Alojamiento.",
      },
      {
        nameTab: "26 de Julio",
        location: "VENECIA - PISA - FLORENCIA",
        activitie:
          "Desayuno. Salida hacia pisa ciudad Toscana que tiene una belleza singular en la Plaza de los Milagros Catedral, Baptisterio y la inigualable Torre Inclinada continuación a Florencia, visita a pie de esta ciudad donde conoceremos el Duomo de Santa Maria dei Fiore el Baptisterio y su famosa Puerta del Paraíso, la Iglesia de la Santa Cruz y la Plaza de la Signoria. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "27 de Julio",
        location: "FLORENCIA - SIENA - ROMA",
        activitie:
          "Desayuno. Salida hacia Siena, admirando su impresionante Plaza del Campo en la que se celebran anualmente las Fiestas Medievales más bellas: “El Palio” en donde los jinetes hacen gala de sus dotes ecuestres. Continuación hacia Roma Ciudad fundada por los hermanos Rómulo y Remo. CENA. Alojamiento.",
      },
      {
        nameTab: "28 de Julio",
        location: "ROMA",
        activitie:
          "Desayuno. Visitaremos la Basílica de San Pedro, Pasearemos por sus numerosas Plazas, la de Venecia, Plaza Navona, Fuente de Trevi, visita exterior al famoso Coliseo Romano. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "29 de Julio",
        location: "ROMA - PISA - NIZA",
        activitie:
          "Desayuno. Salida hacia Pisa ciudad Toscana que tiene un conjunto de belleza singular en la Plaza de los Milagros, Catedral Baptisterio y su famosa Torre Inclinada, continuación a Mónaco situado en la Costa Azul Ciudad bulliciosa y alegre que ofrece numerosos atractivos, visita a Monte Carlo CENA. Alojamiento.",
      },
      {
        nameTab: "30 de Julio",
        location: "NIZA - BARCELONA",
        activitie:
          "Desayuno. Después de admirar los bellos paisajes de la Capital de la Costa Azul, continuaremos a Barcelona. CENA. Alojamiento.",
      },
      {
        nameTab: "31 de Julio",
        location: "BARCELONA",
        activitie:
          "Desayuno. Desayuno. Pasearemos por la Iglesia de la Sagrada Familia, Plaza Cataluña, Estadio Camp Nou, Las Ramblas, tiempo de compras por la tarde. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "01 de Agosto",
        location: "BARCELONA - ZARAGOZA - MADRID",
        activitie:
          "Desayuno. Salida hacia Zaragoza, breve parada para visitar la Basílica del Pilar, COMIDA en típico Restaurante Aragonés. Continuación a Madrid. Alojamiento.",
      },
      {
        nameTab: "02 de Agosto",
        location: "MADRID",
        activitie:
          "Desayuno. Recorreremos sus principales avenidas plazas y monumentos: Paseo de la Castellana, Plaza de Cibeles, Plaza de Neptuno, Plaza de Colón, Parque del retiro. Madrid que es una de las ciudades de Europa que mejor ha sabido combinar lo moderno con lo tradicional. Excursión a la Ciudad Imperial de Toledo. COMIDA en Restaurante Toledano. Alojamiento.",
      },
      {
        nameTab: "03 de Agosto",
        location: "MADRID",
        activitie:
          "Desayuno. Por la mañana visita interior al Estadio Santiago Bernabeu, este día también disfrutaremos de un parque nuevo y divertido Warner Bros Park. CENA.",
      },
      {
        nameTab: "04 de Agosto",
        location: "MADRID - MÉXICO",
        activitie:
          "Desayuno. Traslado al aeropuerto para realizar vuelo intercontinental con destino a México.",
      },
    ],
  },
  {
    title: "Europa 3",
    subtitle: "Disfruta de 23 días en un fabuloso y mágico viaje",
    day: "Itinerario de 23 Días",
    itinerary: [
      {
        nameTab: "¿Qué incluye?",
        location: "",
        activitie:
          "3 Personas Cena de Gala en México, Sesión informativa del programa, Avión (México - París -- Madrid - México), Traslados aeropuertos - hotel - aeropuerto, Autocar de Lujo, Euro Túnel, Calais - Folkestone, Folkestone - Calais, Alojamiento en hoteles de Primera, Alimentos descritos según itinerario, Conductoras desde México, Visitas Panorámicas, Seguro de Viaje, Playera y Mochila",
      },
      {
        nameTab: "¿Qué destinos visitan?",
        location: "",
        activitie:
          "LONDRES, Museo de Cera: Madame Tussauds, Warner Bros: The Making of Harry Potter, Torre de Londres, Cambio de Guardia, London Eye, Hard Rock Café. PARÍS, Visita exterior al Museo de Louvre, Barcos del Sena, Hard Rock Cafe, Torre Eiffel, Euro Disney. ENGELBERG, Monte Titlis. VENECIA: Paseo en Góndola. FLORENCIA, Hard Rock Café. SIENA, Plaza del Campo, Reliquias de Santa Catarina. ROMA, Basílica de San Pedro, Visita exterior al Coliseo Romano, Hard Rock Café. BARCELONA, Camp Nou, Sagrada Familia, Hard Rock Café. ZARAGOZA, Basílica del Pilar, Comida en típico Restaurante Aragonés. MADRID: Estadio Santiago Bernabéu, Warner Bros Park, Hard Rock Café.",
      },
      {
        nameTab: "06 de Julio",
        location: "",
        activitie: "Cena de Gala",
      },
      {
        nameTab: "11 de Julio",
        location: "MÉXICO - PARÍS",
        activitie: "Salida en vuelo Intercontinental con destino a Londres.",
      },
      {
        nameTab: "12 de Julio",
        location: "PARÍS",
        activitie:
          "Llegada al Aeropuerto Charles de Gaulle, traslado al hotel. Alojamiento.",
      },
      {
        nameTab: "13 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Panorámica en autocar viendo los monumentos: la Sorbona, el Panteón, el Palacio y la Torre Eiffel, la Plaza de la Concordia, el Arco del Triunfo, la Plaza Vendome, la Ópera. COMIDA en Hard Rock Cafe. Disfrutaremos un paseo en Barco por el Río Sena, Tiempo de Compras en los Campos Elíseos. Alojamiento.",
      },
      {
        nameTab: "14 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Esta mañana la dedicaremos una visita exterior al Museo de Louvre y por la tarde visitaremos EURO DISNEY. Alojamiento.",
      },
      {
        nameTab: "15 de Julio",
        location: "PARÍS - LONDRES",
        activitie:
          "Desayuno. Salida a Calais para atravesar el Canal de la Mancha. Continuación a Londres. Alojamiento.",
      },
      {
        nameTab: "16 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Visita de la ciudad admirando La Torre y el Puente de Londres, El Palacio de Buckingham (Cambio De Guardia si se realiza), los preciosos Hyde Park y Saint James Park las calles de la moda. Por la tarde visita a la famosa Noria de Londres (London Eye). Tiempo de Compras en Piccadilly Circus. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "17 de Julio",
        location: "LONDRES - BRUJAS - BRUSELAS",
        activitie:
          "Desayuno. Saldremos a primera hora para atravesar el Canal de la Mancha y llegar a Brujas “La Bella” una de las más pintorescas ciudades de Europa, un museo romántico al aire libre hecho de iglesias, casas principales, canales famosos donde realizaremos un paseo. Tendremos tiempo para comprar sus famosos encajes, cerámica y chocolates. Continuación a Bruselas para conocer su Gran Plaza y el Mennenken Pis, uno de los grandes símbolos de la ciudad. Alojamiento.",
      },
      {
        nameTab: "18 de Julio",
        location: "BRUSELAS - NUREMBERG",
        activitie:
          "Desayuno. Salida a Núremberg, visita a pie por la ciudad antigua “pintoresca” de la Baviera, pasaremos por las murallas medievales con coloridos edificios, aprenderemos sobre las raíces Romanas y vínculos con el Tercer Reich (inicio del régimen Nazi) caminaremos junto al Río Pegnitz, la iglesia de San Lorenzo y el Castillo de Núremberg. CENA. Alojamiento.",
      },
      {
        nameTab: "19 de Julio",
        location: "NUREMBERG - ENGELBERG - LUCERNA",
        activitie:
          "Desayuno. Salida a Engelberg donde visitaremos Monte Titlis con el único funicular giratorio en el mundo donde nos sorprenderán sus impresionantes paisajes y en lo más alto disfrutaremos de la nieve. Continuación a Lucerna, disfrutando de esta Bella ciudad situada a las orillas del lago, donde se podrá Admirar su Puente Medieval, así como la ciudad vieja. CENA. Alojamiento.",
      },
      {
        nameTab: "20 de Julio",
        location: "LUCERNA - INNSBRUK - VIENA",
        activitie:
          "Desayuno. Salida a Innsbruck. Visitaremos a pie esta ciudad situada en el interior de la Cadena Alpina. Capital del Tirol, una de las regiones más atractivas de Europa por el incomparable marco de sus montañas y su cielo limpio. La ciudad se encuentra rodeada de maravillosos paisajes y centros deportivos de invierno. Continuación a Viena. CENA. Alojamiento.",
      },
      {
        nameTab: "21 de Julio",
        location: "VIENA",
        activitie:
          "Desayuno. Visitaremos la ciudad, bañada por el Danubio, Antigua capital del Imperio Austrohúngaro, en el centro de Viena se encuentra la antigua Ciudad Imperial con el Palacio Hofburg residencia de los Emperadores, visitaremos los Jardines de Belvedere y el Palacio Schönbrunn la Iglesia de Votiva, la Catedral de San Esteban la Ópera. Por la noche GRAN CENA BAILE. Alojamiento.",
      },
      {
        nameTab: "22 de Julio",
        location: "VIENA - VENECIA",
        activitie:
          "Desayuno. Salida a Venecia, atravesando la bella región de los Lagos Austriacos. Alojamiento.",
      },
      {
        nameTab: "23 de Julio",
        location: "VENECIA",
        activitie:
          "Desayuno. Visita a pie de esta ciudad única en el mundo asentada sobre 118 islas en el Mar Adriático. Es impresionante la Plaza de San Marcos que forma un maravilloso conjunto arquitectónico con la Basílica de San Marcos Puente de los Suspiros, Campanille y Palacio Ducal pasearemos en Góndola por sus innumerables canales, traslado a Lido de Venecia para disfrutar de un buen chapuzón en el Mar Adriático. CENA. Alojamiento.",
      },
      {
        nameTab: "24 de Julio",
        location: "VENECIA - ROMA",
        activitie:
          "Desayuno. Continuación hacia Roma Ciudad fundada por los hermanos Rómulo y Remo. CENA. Alojamiento.",
      },
      {
        nameTab: "25 de Julio",
        location: "ROMA",
        activitie:
          "Desayuno. Visitaremos la Basílica de San Pedro, Pasearemos por sus numerosas Plazas, la de Venecia, Plaza Navona, Fuente de Trevi, visita exterior al famoso Coliseo Romano. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "26 de Julio",
        location: "ROMA - SIENA - FLORENCIA",
        activitie:
          "Desayuno. Salida hacia Siena, admirando su impresionante Plaza del Campo en la que se celebran anualmente las Fiestas Medievales más bellas: “El Palio” en donde los jinetes hacen gala de sus dotes ecuestres. Continuación del viaje hacia Florencia. CENA. Alojamiento.",
      },
      {
        nameTab: "27 de Julio",
        location: "FLORENCIA - PISA - NIZA",
        activitie:
          "Desayuno. Salida hacia Pisa, ciudad Toscana que tiene un conjunto de belleza singular en la Plaza de los Milagros, Catedral, Baptisterio y la inigualable Torre Inclinada, tiempo para compras continuación al principado de Mónaco y Montecarlo para conocer el mundialmente famoso Casino.",
      },
      {
        nameTab: "28 de Julio",
        location: "NIZA - BARCELONA",
        activitie:
          "Desayuno. Después de admirar los bellos paisajes de la Capital de la Costa Azul, continuaremos a Barcelona. CENA. Alojamiento.",
      },
      {
        nameTab: "29 de Julio",
        location: "BARCELONA",
        activitie:
          "Desayuno. Pasearemos por la iglesia de la Sagrada Familia, Plaza Cataluña, Estadio Camp Nou, las Ramblas. Tiempo de compras. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "30 de Julio",
        location: "BARCELONA - ZARAGOZA - MADRID",
        activitie:
          "Desayuno. Salida hacia Zaragoza, breve parada para visitar la Basílica del Pilar. COMIDA en típico Restaurante Aragonés, continuación a Madrid. Alojamiento.",
      },
      {
        nameTab: "31 de Agosto",
        location: "MADRID",
        activitie:
          "Desayuno. Recorreremos sus principales avenidas, plazas y monumentos: Paseo de la Castellana, Plaza de Cibeles, Plaza de Neptuno, Plaza de Colón, Parque del retiro. Madrid que es una de las ciudades de Europa que mejor ha sabido combinar lo moderno con lo tradicional. Excursión a la Ciudad Imperial de Toledo. COMIDA en Restaurante Toledano. Alojamiento.",
      },
      {
        nameTab: "01 de Agosto",
        location: "MADRID",
        activitie:
          "Desayuno. Por la mañana visita al Estadio Santiago Bernabeu este día también disfrutaremos de un parque nuevo y divertido Warner Bros Park. CENA. Alojamiento.",
      },
      {
        nameTab: "02 de Agosto",
        location: "MADRID - MÉXICO",
        activitie:
          "Desayuno. Traslado al aeropuerto para realizar vuelo intercontinental con destino a México.",
      },
    ],
  },
  {
    title: "Europa 4",
    subtitle: "¡19 días, un viaje, mil recuerdos!",
    day: "Itinerario de 19 Días",
    itinerary: [
      {
        nameTab: "¿Qué incluye?",
        location: "",
        activitie:
          "Sesión informativa del programa, Avión (México - Londres -- Madrid - México), Traslados aeropuertos - hotel - aeropuerto, Autocar de Lujo, Euro Túnel Calais - Folkestone, Folkestone - Calais, Alojamiento en hoteles Turista, Alimentos descritos según itinerario, Conductoras desde México, Visitas Panorámicas, Seguro de Viaje, Playera y Mochila",
      },
      {
        nameTab: "¿Qué destinos visitan?",
        location: "",
        activitie:
          "PARÍS, Museo de Louvre, Barcos del Sena, Comida en Hard Rock, Torre Eiffel, Euro Disney, LONDRES, Warner Bros: The Making of Harry Potter, Museo de Cera: Madame Tussauds, Cambio de Guardia, London Eye, Hard Rock Café, ENGELBERG, Monte Titlis, MONACO, Casino de Montecarlo, VENECIA, Paseo en Góndola, Isla del Lido de Venecia, FLORENCIA, Hard Rock Café, SIENA, Plaza del Campo, Reliquias de Santa Catarina, ROMA, Basílica de San Pedro, Visita exterior al Coliseo Romano, Hard Rock Café, BARCELONA, Camp Nou, Sagrada Familia, Hard Rock Cafe, ZARAGOZA, Basílica del Pilar, MADRID, Estadio Santiago Bernabéu, Warner Bros Park, Toledano",
      },
      {
        nameTab: "12 de Julio",
        location: "MÉXICO - LONDRES",
        activitie: "Salida en vuelo intercontinental con destino a Londres.",
      },
      {
        nameTab: "13 de Julio",
        location: "LONDRES",
        activitie:
          "Llegada al aeropuerto de Heathrow, traslado al hotel. CENA. Alojamiento.",
      },
      {
        nameTab: "14 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Visita de la ciudad admirando La Torre y el Puente de Londres, El Palacio de Buckingham (Cambio De Guardia si se realiza), los preciosos Hyde Park y Saint James Park, las calles de la moda. Por la tarde visita a la famosa Noria de Londres (London Eye). Tiempo de Compras en Piccadilly Circus. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "15 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Por la mañana visita al Museo de Cera Madame Tussauds. Por la tarde disfrutaremos de los Estudios Warner Bros para imaginar cómo se filmaron las hermosas películas de Harry Potter. CENA. Alojamiento.",
      },
      {
        nameTab: "16 de Julio",
        location: "LONDRES - BRUJAS - PARÍS",
        activitie:
          "Desayuno. Salida hacia Dover para cruzar el Canal de la Mancha y llegar a Calais en Ferry. Continuación a Brujas 'La Bella', una de las más pintorescas ciudades de Europa. Continuación a París. Alojamiento.",
      },
      {
        nameTab: "17 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Panorámica en autocar viendo los monumentos: la Sorbona, el Panteón, el Palacio y la Torre Eiffel, la Plaza de la Concordia, el Arco del Triunfo, la Plaza Vendome, y la Ópera. COMIDA en Hard Rock Cafe. Paseo en Barco por el Río Sena. Tiempo de Compras en los Campos Elíseos. Alojamiento.",
      },
      {
        nameTab: "18 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Visita exterior al Museo de Louvre y por la tarde visita a EURO DISNEY. Alojamiento.",
      },
      {
        nameTab: "19 de Julio",
        location: "PARÍS - LUCERNA",
        activitie: "Desayuno. Salida a Lucerna. Alojamiento.",
      },
      {
        nameTab: "20 de Julio",
        location: "LUCERNA - ENGELBERG - VENECIA",
        activitie:
          "Desayuno. Visita a Monte Titlis con el único funicular giratorio en el mundo. Continuación a Venecia. Alojamiento.",
      },
      {
        nameTab: "21 de Julio",
        location: "VENECIA - FLORENCIA",
        activitie:
          "Desayuno. Visita de la ciudad de Venecia, incluyendo la Plaza de San Marcos, la Basílica de San Marcos, el Puente de los Suspiros, el Campanille, y el Palacio Ducal. Paseo en Góndola. Traslado a Florencia. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "22 de Julio",
        location: "FLORENCIA - SIENA - ROMA",
        activitie:
          "Desayuno. Salida hacia Siena, visita a la Plaza del Campo. Continuación a Roma. Alojamiento.",
      },
      {
        nameTab: "23 de Julio",
        location: "ROMA",
        activitie:
          "Desayuno. Visita a la Basílica de San Pedro, Plaza de Venecia, Plaza Navona, Fuente de Trevi, y visita exterior al Coliseo Romano. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "24 de Julio",
        location: "ROMA - PISA - NIZA",
        activitie:
          "Desayuno. Salida hacia Pisa, visita a la Plaza de los Milagros y la Torre Inclinada. Continuación a Niza, visita a Monte Carlo. Alojamiento.",
      },
      {
        nameTab: "25 de Julio",
        location: "NIZA - BARCELONA",
        activitie: "Desayuno. Salida hacia Barcelona.",
      },
      {
        nameTab: "26 de Julio",
        location: "BARCELONA",
        activitie:
          "Desayuno. Visita a la iglesia de la Sagrada Familia, Plaza Cataluña, Estadio Camp Nou, las Ramblas. Tiempo de compras. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "27 de Julio",
        location: "BARCELONA - ZARAGOZA - MADRID",
        activitie:
          "Desayuno. Salida hacia Zaragoza, breve parada para visitar la Basílica del Pilar. Continuación a Madrid. Alojamiento.",
      },
      {
        nameTab: "28 de Julio",
        location: "MADRID",
        activitie:
          "Desayuno. Recorreremos sus principales avenidas y monumentos: Paseo de la Castellana, Plaza de Cibeles, Plaza de Neptuno, Plaza de Colón, Parque del Retiro. Excursión a Toledo. COMIDA en Restaurante Toledano. Alojamiento.",
      },
      {
        nameTab: "29 de Julio",
        location: "MADRID",
        activitie:
          "Desayuno. Visita al Estadio Santiago Bernabéu. Disfrutaremos de un día en Warner Bros Park. Alojamiento.",
      },
      {
        nameTab: "30 de Julio",
        location: "MADRID - MÉXICO",
        activitie:
          "Desayuno. Traslado al aeropuerto para vuelo intercontinental con destino a México.",
      },
    ],
  },
  {
    title: "Europa 5",
    subtitle: "¡19 días, un viaje, mil recuerdos!",
    day: "Itinerario de 19 Días",
    itinerary: [
      {
        nameTab: "¿Qué incluye?",
        location: "",
        activitie:
          "Sesión informativa del programa, Avión (México - Londres -- Madrid - México), Traslados aeropuertos - hotel - aeropuerto, Autocar de Lujo, Euro Túnel Calais - Folkestone, Folkestone - Calais, Alojamiento en hoteles Turista, Alimentos descritos según itinerario, Conductoras desde México, Visitas Panorámicas, Seguro de Viaje, Playera y Mochila",
      },
      {
        nameTab: "¿Qué destinos visitan?",
        location: "",
        activitie:
          "PARÍS, Museo de Louvre, Barcos del Sena, Comida en Hard Rock, Torre Eiffel, Euro Disney, LONDRES, Warner Bros: The Making of Harry Potter, Museo de Cera: Madame Tussauds, Cambio de Guardia, London Eye, Hard Rock Café, ENGELBERG, Monte Titlis, MONACO, Casino de Montecarlo, VENECIA, Paseo en Góndola, Isla del Lido de Venecia, FLORENCIA, Hard Rock Café, SIENA, Plaza del Campo, Reliquias de Santa Catarina, ROMA, Basílica de San Pedro, Visita exterior al Coliseo Romano, Hard Rock Café, BARCELONA, Camp Nou, Sagrada Familia, Hard Rock Cafe, ZARAGOZA, Basílica del Pilar, MADRID, Estadio Santiago Bernabéu, Warner Bros Park, Toledano",
      },
      {
        nameTab: "08 de Julio",
        location: "MÉXICO - LONDRES",
        activitie: "Salida en vuelo intercontinental con destino a Londres.",
      },
      {
        nameTab: "09 de Julio",
        location: "LONDRES",
        activitie:
          "Llegada al aeropuerto de Heathrow, traslado al hotel. CENA. Alojamiento.",
      },
      {
        nameTab: "10 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Visita de la ciudad admirando La Torre y el Puente de Londres, El Palacio de Buckingham (Cambio De Guardia si se realiza), los preciosos Hyde Park y Saint James Park, las calles de la moda. Por la tarde visita a la famosa Noria de Londres (London Eye). Tiempo de Compras en Piccadilly Circus. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "11 de Julio",
        location: "LONDRES",
        activitie:
          "Desayuno. Por la mañana visita al Museo de Cera Madame Tussauds. Por la tarde disfrutaremos de los Estudios Warner Bros para imaginar cómo se filmaron las hermosas películas de Harry Potter. CENA. Alojamiento.",
      },
      {
        nameTab: "12 de Julio",
        location: "LONDRES - BRUJAS - PARÍS",
        activitie:
          "Desayuno. Salida hacia Dover para cruzar el Canal de la Mancha y llegar a Calais en Ferry. Continuación a Brujas 'La Bella', una de las más pintorescas ciudades de Europa. Continuación a París. Alojamiento.",
      },
      {
        nameTab: "13 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Panorámica en autocar viendo los monumentos: la Sorbona, el Panteón, el Palacio y la Torre Eiffel, la Plaza de la Concordia, el Arco del Triunfo, la Plaza Vendome, y la Ópera. COMIDA en Hard Rock Cafe. Paseo en Barco por el Río Sena. Tiempo de Compras en los Campos Elíseos. Alojamiento.",
      },
      {
        nameTab: "14 de Julio",
        location: "PARÍS",
        activitie:
          "Desayuno. Visita exterior al Museo de Louvre y por la tarde visita a EURO DISNEY. Alojamiento.",
      },
      {
        nameTab: "15 de Julio",
        location: "PARÍS - LUCERNA",
        activitie: "Desayuno. Salida a Lucerna. Alojamiento.",
      },
      {
        nameTab: "16 de Julio",
        location: "LUCERNA - ENGELBERG - VENECIA",
        activitie:
          "Desayuno. Visita a Monte Titlis con el único funicular giratorio en el mundo. Continuación a Venecia. Alojamiento.",
      },
      {
        nameTab: "17 de Julio",
        location: "VENECIA - FLORENCIA",
        activitie:
          "Desayuno. Visita de la ciudad de Venecia, incluyendo la Plaza de San Marcos, la Basílica de San Marcos, el Puente de los Suspiros, el Campanille, y el Palacio Ducal. Paseo en Góndola. Traslado a Florencia. CENA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "18 de Julio",
        location: "FLORENCIA - SIENA - ROMA",
        activitie:
          "Desayuno. Salida hacia Siena, visita a la Plaza del Campo. Continuación a Roma. Alojamiento.",
      },
      {
        nameTab: "19 de Julio",
        location: "ROMA",
        activitie:
          "Desayuno. Visita a la Basílica de San Pedro, Plaza de Venecia, Plaza Navona, Fuente de Trevi, y visita exterior al Coliseo Romano. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "20 de Julio",
        location: "ROMA - PISA - NIZA",
        activitie:
          "Desayuno. Salida hacia Pisa, visita a la Plaza de los Milagros y la Torre Inclinada. Continuación a Niza, visita a Monte Carlo. Alojamiento.",
      },
      {
        nameTab: "21 de Julio",
        location: "NIZA - BARCELONA",
        activitie: "Desayuno. Salida hacia Barcelona.",
      },
      {
        nameTab: "22 de Julio",
        location: "BARCELONA",
        activitie:
          "Desayuno. Visita a la iglesia de la Sagrada Familia, Plaza Cataluña, Estadio Camp Nou, las Ramblas. Tiempo de compras. COMIDA en Hard Rock Cafe. Alojamiento.",
      },
      {
        nameTab: "23 de Julio",
        location: "BARCELONA - ZARAGOZA - MADRID",
        activitie:
          "Desayuno. Salida hacia Zaragoza, breve parada para visitar la Basílica del Pilar. Continuación a Madrid. Alojamiento.",
      },
      {
        nameTab: "24 de Julio",
        location: "MADRID",
        activitie:
          "Desayuno. Recorreremos sus principales avenidas y monumentos: Paseo de la Castellana, Plaza de Cibeles, Plaza de Neptuno, Plaza de Colón, Parque del Retiro. Excursión a Toledo. COMIDA en Restaurante Toledano. Alojamiento.",
      },
      {
        nameTab: "25 de Julio",
        location: "MADRID",
        activitie:
          "Desayuno. Visita al Estadio Santiago Bernabéu. Disfrutaremos de un día en Warner Bros Park. Alojamiento.",
      },
      {
        nameTab: "26 de Julio",
        location: "MADRID - MÉXICO",
        activitie:
          "Desayuno. Traslado al aeropuerto para vuelo intercontinental con destino a México.",
      },
    ],
  },
  {
    title: "DUBÁI",
    subtitle: "Un fabuloso y mágico viaje",
    day: "Itinerario de 6 Días",
    itinerary: [
      {
        nameTab: "¿Qué incluye?",
        location: "",
        activitie:
          "Sesión informativa del programa (3 Personas) Cena de Gala en México, Avión México - Dubái - México, Traslados aeropuerto - hotel – aeropuerto, Alojamiento en hoteles de Lujo, Autocar de Lujo, Alimentos descritos según itinerario, Guía Especializado en Dubái, Conductoras desde México, Visitas panorámicas con guías locales, Seguro de Viaje, Playera y Mochila",
      },
      {
        nameTab: "¿Qué destinos visitan?",
        location: "",
        activitie:
          "DUBÁI: Recorrido panorámico de Dubái, Burj Al Arab, Burj Khalifa, Paseo en barco, Parque Acuático Aquaventure. ABU DHABI: Recorrido panorámico de Abu Dhabi, La Gran Mezquita, Parque Ferrari World",
      },
      {
        nameTab: "15 de Julio",
        location: "MÉXICO - DUBÁI",
        activitie: "Salida en vuelo Intercontinental destino a Dubái.",
      },
      {
        nameTab: "16 de Julio",
        location: "DUBÁI",
        activitie:
          "Desayuno. Por la mañana disfrutaremos de los atractivos del Hotel, por la tarde salida al desierto para paseo en camionetas 4 X 4 por las Dunas, pasearemos en camello y tendremos un bello SHOW ÁRABE con una exquisita CENA. Alojamiento.",
      },
      {
        nameTab: "17 de Julio",
        location: "DUBÁI",
        activitie:
          "Desayuno. Visita panorámica de la ciudad admirando las Magníficas vistas de la Ensenada de Dubái Creek, pasando por el área de Bastakiya y sus fascinantes casas antiguas, la Fortaleza de Al Fahidi, el Burj Al Arab conocido como el Hotel más Lujoso del Mundo, tomaremos té en el museo antiguo y compras en el Mercado de Oro. CENA. Alojamiento.",
      },
      {
        nameTab: "18 de Julio",
        location: "DUBÁI",
        activitie:
          "Desayuno. Salida a Burj Khalifa, y disfrutaremos de las bellas visitas en lo más alto de Burj Khalifa, el rascacielos más alto del mundo, visitaremos el Dubai Mall y el Acuario más grande del mundo, tiempo de compras. CENA. Alojamiento.",
      },
      {
        nameTab: "19 de Julio",
        location: "DUBÁI - ABU DHABI - DUBAÍ",
        activitie:
          "Desayuno. Esta mañana saldremos hacia Abu Dhabi la capital de los Emiratos Árabes Unidos, donde se sentirán cautivados por la grandeza de esta Ciudad admirando entre otras cosas, la Gran Mezquita que es una de las mezquitas más grandes del mundo, continuación al Parque Ferrari World donde visitaremos simuladores en los cuales viajaremos a través de la historia de Ferrari. Continuación hacia Dubái para disfrutar un hermoso recorrido en sus canales en barco donde tendremos una deliciosa CENA. Alojamiento.",
      },
      {
        nameTab: "20 de Julio",
        location: "DUBÁI - MÉXICO",
        activitie:
          "Desayuno. Traslado al aeropuerto para realizar vuelo intercontinental con destino a México.",
      },
    ],
  },
];

/**
 * Devuelve un string con la cantidad de habitaciones, adultos y menores
 * según el array de habitaciones que se le pase como parámetro.
 * @param {Array} arrayHotel - Arreglo de objetos con la información de cada habitación.
 * @returns {string} - Un string con la cantidad de habitaciones, adultos y menores.
 */
export const setLabelPax = (arrayHotel) => {
  // Determinar la estructura del array
  const isNewFormat =
    arrayHotel.length > 0 && arrayHotel[0].hasOwnProperty("room");

  // Sumar adultos y menores según el formato
  let sumAdults = arrayHotel.reduce(
    (acumulador, actual) =>
      acumulador + (isNewFormat ? actual.adults : actual.num_adultos),
    0
  );

  let sumKids = arrayHotel.reduce(
    (acumulador, actual) =>
      acumulador + (isNewFormat ? actual.minors : actual.num_menores),
    0
  );

  // Generar etiquetas
  let roomLabel = arrayHotel.length > 1 ? "Habitaciones" : "Habitación";
  let adultsLabel = sumAdults > 1 ? "Adultos" : "Adulto";
  let kidsLabel = sumKids === 1 ? "Menor" : "Menores";

  return `${arrayHotel.length} ${roomLabel}, ${sumAdults} ${adultsLabel}, ${sumKids} ${kidsLabel}`;
};

/**
 * Formatea un valor numérico como una cadena con el formato de moneda
 * @param {Number} value - Valor numérico a formatear
 * @returns {String} Cadena con el valor formateado con el formato de moneda
 */
export const Currency = (value, currency = "USD") => {
  let locale = "en-US";
  currency === "" && (currency = "USD");

  const formattedValue = new Intl.NumberFormat(locale, {
    currency: currency,
    style: "currency",
  }).format(value);

  return formattedValue;
};

/**
 * Convierte un string en formato ISO a una fecha en formato aaaa-mm-dd
 * @param {string} isoString - Fecha en formato ISO
 * @returns {string} - Fecha en formato aaaa-mm-dd
 */
export const FormatDate = (isoString) => {
  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, "0"); // Día del mes
  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const month = monthNames[date.getMonth()]; // Nombre del mes
  const year = date.getFullYear(); // Año completo

  return `${day} de ${month} del ${year}`;
};

export const fetchMarkup = async () => {
  try {
    const response = await getMarkup();
    return response;
  } catch (error) {
    console.error("Error fetching rates:", error);
    return [];
  }
};

export const totalPrices = (sellingRate, nights, markup) => {
  let rate = Math.round(sellingRate * ((markup + 100) / 100));
  let ratePerNight = Math.floor(rate / nights);

  return [ratePerNight, rate];
};

export const FormatCancellationPolicies = (isoString) => {
  const date = new Date(isoString);

  const day = isoString?.split("T")[0].split("-")[2]; // Día del mes
  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const month = monthNames[date.getMonth()]; // Nombre del mes
  const year = date.getFullYear(); // Año completo
  const hours = isoString?.split("T")[1]; // Horas

  return `${day} de ${month} del ${year} a las ${hours}`;
};

/**
 * Calcula las fechas de reserva para el check-in y el check-out.
 *
 * La función establece la fecha de check-in en 5 días a partir de hoy
 * y la fecha de check-out en 3 días después de la fecha de check-in.
 * Las fechas tienen el formato 'aaaa-mm-dd'.
 *
 * @returns {Object} Un objeto que contiene fechas de entrada y salida formateadas.
 * @property {string} checkIn: fecha de entrada con el formato 'aaaa-mm-dd'.
 * @property {string} checkOut: fecha de salida con el formato 'aaaa-mm-dd'.
 */

export const calculateBookingDates = () => {
  const today = new Date();

  // Check-in: 5 días desde hoy
  const checkIn = new Date(today);
  checkIn.setDate(today.getDate() + 5);

  // Check-out: 3 días después del check-in
  const checkOut = new Date(checkIn);
  checkOut.setDate(checkIn.getDate() + 3);

  // Formatear las fechas a yyyy-mm-dd
  const formatDate = (date) => date.toISOString().split("T")[0];

  return {
    checkIn: formatDate(checkIn),
    checkOut: formatDate(checkOut),
  };
};
